import { store } from 'redux/store';
import { useCallback, useEffect, useRef, useState } from 'react';
import { getIncentiveOffers } from '../redux/incentiveOfferActions';

const EMPTY_FILTERS: string[] = [];

type UseGetIncentiveOffersProps = {
  societyId?: string;
  page?: number;
  rowsPerPage?: number;
  filters?: string[];
  refetchKey?: number;
};

export const useGetIncentiveOffers = ({
  societyId,
  page = 1,
  rowsPerPage = 10,
  filters = EMPTY_FILTERS,
  refetchKey = 0,
}: UseGetIncentiveOffersProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const fetchIncentiveOffers = useCallback(
    async (controller: AbortController) => {
      if (!societyId) return;

      try {
        setIsLoading(true);

        await store.dispatch(
          getIncentiveOffers({
            societyId,
            params: {
              page,
              items: rowsPerPage,
              incentiveOfferTypes: filtersRef.current,
            },
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    // refetchKey intencional para forzar refetch
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, rowsPerPage, societyId, refetchKey]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchIncentiveOffers(controller);

    return () => controller.abort();
  }, [fetchIncentiveOffers]);

  return {
    isLoading,
    isError,
  };
};
